import React, { HTMLProps } from 'react';

// @ts-ignore FIXME - Typescript Strict [7016]
import VisibilitySensor from 'react-visibility-sensor';
import dynamic from 'next/dynamic';
import Spinner from 'react-scale/components/elements/spinner';

const LidarZoid = dynamic<ILidarZoidProps>(() => import('./LidarZoidDriver'), {
  ssr: false
});

interface ILidarIframeState {
  shouldRender: boolean;
  hideSpinner: boolean;
}

interface ILidarZoidProps {
  title?: string;
  frames?: string[];
  annotations?: string;
  showImages?: boolean;
  showLogo?: boolean;
  frame?: number;
  updateAnnotations?: (annotations: []) => void;
  updateFrame?: (frame: number) => void;
  hideAnnotationsByLabel: string[];
  bgColor: string;
}

interface ILidarIframeProps extends ILidarZoidProps, HTMLProps<HTMLDivElement> {
  zoid?: boolean;
}

export default class LidarIframe extends React.Component<ILidarIframeProps, ILidarIframeState> {
  state: ILidarIframeState = {
    shouldRender: false,
    hideSpinner: false
  };
  // @ts-ignore FIXME - Typescript Strict [2564]
  timeout: NodeJS.Timer;
  static defaultProps = {
    className: '',
    src: 'https://lidar-now.scale.com/examples/demo',
    zoid: false,
    title: '',
    frames: [],
    annotations: '',
    showImages: false,
    showLogo: true,
    frame: 0,
    hideAnnotationsByLabel: [],
    bgColor: '#000000'
  };

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
  handleVisibilityChange = (isVisible: $FIXME) => {
    const { shouldRender } = this.state;

    if (isVisible && !shouldRender) {
      this.setState({ shouldRender: true }, () => {
        this.timeout = setTimeout(() => {
          this.setState({ hideSpinner: true });
        }, 2000);
      });
    }
  };

  render() {
    const {
      className,
      src,
      zoid,
      title,
      frames,
      annotations,
      showImages,
      showLogo,
      frame,
      updateAnnotations,
      updateFrame,
      hideAnnotationsByLabel,
      bgColor
    } = this.props;
    const { shouldRender, hideSpinner } = this.state;
    return (
      <VisibilitySensor partialVisibility onChange={this.handleVisibilityChange} scrollCheck>
        <div className={className}>
          {!hideSpinner && (
            <div className="spinner-wrapper">
              <Spinner />
            </div>
          )}
          {shouldRender && !zoid && <iframe className="aspect-video" src={src} allowFullScreen />}
          {shouldRender && zoid && (
            <div className="zoid-wrapper">
              <LidarZoid
                title={title}
                frames={frames}
                annotations={annotations}
                showImages={showImages}
                showLogo={showLogo}
                frame={frame}
                key={title}
                updateAnnotations={updateAnnotations}
                updateFrame={updateFrame}
                hideAnnotationsByLabel={hideAnnotationsByLabel}
                bgColor={bgColor}
              />
            </div>
          )}
          <style jsx global>{`
            .zoid-wrapper div {
              height: 100%;
            }
            .zoid-wrapper iframe {
              width: 100%;
              height: 512px;
              border: 0;
              display: inline-block;
              vertical-align: middle;
            }
            @media (min-width: 768px) {
              .zoid-wrapper iframe {
                width: 100%;
                height: 100%;
              }
            }
          `}</style>
          <style jsx>{`
            div {
              height: 100%;
              width: 100%;
              background-color: ${bgColor};
              user-select: none;
            }
            div .spinner-wrapper {
              display: flex;
              align-items: center;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
            }
            @media (min-width: 768px) {
              div.full-screen {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
              }
            }
            @media (min-width: 768px) {
              div.full-screen iframe {
                width: 100%;
                height: 100%;
              }
            }
            div.height-100 iframe {
              height: 100%;
            }
            @media (min-width: 768px) {
              div.height-100 iframe {
                height: 100%;
              }
            }

            iframe {
              width: 100%;
              border: 0;
              display: inline-block;
              vertical-align: middle;
            }
          `}</style>
        </div>
      </VisibilitySensor>
    );
  }
}
